
import NotificationStatus from "../../../assets/filled/NotificationStatus.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function NotificationStatusIcon({ className, dataTestid = "NotificationStatusIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <NotificationStatus data-testid={dataTestid} className={classes} {...rest} />
  );
}
